<div class="typo-small">
    <div [hidden]="visibilityController.areaVisible">
      <exg-input #VCInput
                 (focusin)="changeFocus($event);"
                 [(ngModel)]="_value"
                 [caption]="caption"
                 name="Input" type="text">
      </exg-input>
    </div>
    <div [hidden]="!visibilityController.areaVisible">
      <exg-textarea #VCInputArea
                    (focusout)="changeFocus($event)"
                    [(ngModel)]="_value"
                    [caption]="caption"
                    name="InputArea">
      </exg-textarea>
      <div class="spawn-reverse app-textcount">
        <span>(Zeichen: {{value.length}}{{maxCLength ? ' | ' + maxCLength.toString() : ''}})</span>
      </div>
    </div>
</div>
